import { lightTheme } from "../theme/theme";

type Theme = typeof lightTheme;
export const GlobalStyles = (theme: Theme) => ({
  page: {
    backgroundColor: theme.background,
    color: theme.text,
    fontFamily: "'Poppins', sans-serif",
  },
  pageTitle: {
    fontSize: 40,
    lineHeight: 1.15,
    margin: "8px 0 6px",
    fontFamily: '"Playfair Display", Georgia, serif',
    fontWeight: 700,
    fontStyle: "italic",
  },
  pageSubTitle: {
    fontSize: 16,
    opacity: 0.85,
    maxWidth: 780,
    marginBottom: 18,
  },
  section: { maxWidth: 1140, margin: "40px auto", padding: "0 16px" },
  sectionTitle: {
    fontFamily: '"Playfair Display", Georgia, serif',
    fontWeight: 600,
    fontStyle: "italic",
    fontSize: "clamp(20px, 3vw, 28px)",
    marginBottom: 14,
  },
  featureTitle: { fontWeight: 800, marginBottom: 6 },
  featureText: { fontSize: 14, color: theme.status },
  mutedSubTitle: { color: theme.muted, maxWidth: 420 },
  cardGrid: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fill, minmax(280px, 1fr))",
    gap: 20,
    rowGap: 20,
  },
  card: {
    width: "100%",
    border: `1px solid ${theme.primary}22`,
    background: theme.card ?? "#fff",
    overflow: "hidden",
    display: "flex",
    flexDirection: "column" as const,
    boxShadow: "0 6px 18px rgba(0,0,0,0.06)",
    transition:
      "transform .25s ease, box-shadow .25s ease, border-color .25s ease",
    textDecoration: "none",
    color: theme.text,
  },
  ctaText: {
    color: theme.text,
    fontFamily: "'Poppins', sans-serif",
    fontWeight: 700,
  },
  btnPrimary: {
    fontFamily: "'Poppins', sans-serif",
    textDecoration: "none",
    backgroundColor: theme.primary,
    color: theme.hoverText,
    padding: "10px 16px",

    fontWeight: 700,
    border: `1px solid ${theme.primary}`,
  },
  btnSecondary: {
    fontFamily: "'Poppins', sans-serif",
    textDecoration: "none",
    backgroundColor: "transparent",
    color: theme.btn,
    padding: "10px 16px",

    fontWeight: 700,
    border: `2px solid ${theme.btn}`,
    boxShadow: `0 0 0 2px ${theme.background}, 0 0 0 4px ${theme.primary}22`,
  },
});
